import GPT from "../gpt/GPT";
import Ad from "../gpt/Ad";

/**
 * Instantly render ad
 *
 */
export default class InstantRenderRenderingStrategy {

    /**
     * @constructs InstantRenderRenderingStrategy
     */

    _gpt: GPT;
    _services: string[];

    constructor(gpt: GPT) {
        this._gpt = gpt;
        this._services = [gpt.services.pubads];
    }

    /**
     * Add the ad to the set of unrendered ads and start the state machine
     */
    render(ad: Ad): void {
        this._gpt.renderInstant(ad, { services: this._services });
    }

    /**
     * Refreshes the list of ads immediately
     */
    refresh(ads: Ad[]): void {
        this._gpt.refresh(ads);
    }

}
